module.exports = __webpack_public_path__ + "img/passcode.775f72ea.svg";